<template>
  <ul>
    <li class="item" v-for="(item, index) in data" :key="index">
      <div class="time">
        {{ item.gmtCreated | parseTime }}
      </div>
      <div class="tail"></div>
      <div class="node"></div>
      <div class="content">
        <div class="f-14 c-3">{{ item.subject }}</div>
        <div class="f-12 c-9 m-t8">操作人：{{ item.operatorName }}</div>
        <div class="f-12 c-9 m-t8">备注信息：{{ item.remark }}</div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TimeLine',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  padding-bottom: 30px;

  .time {
    position: absolute;
    font-size: 12px;
    color: #999;
    width: 100px;
    text-align: right;
  }
  .tail {
    position: absolute;
    left: 110px;
    top: 3px;
    height: 100%;
    border-left: 1px solid #c7ccd6;
  }
  .node {
    position: absolute;
    background-color: #c7ccd6;
    border-radius: 50%;
    left: 107px;
    transform: translateX(0.5px);
    top: 3px;
    width: 6px;
    height: 6px;
  }
  .content {
    position: relative;
    padding-left: 130px;
    top: 0;
  }
  &:first-child {
    .node {
      background-color: #d0111a;
    }
  }
  &:last-child {
    .tail {
      display: none;
    }
  }
}
</style>
